import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "en",
	ns: ["translations"],
	resources: messages,
	// O detector guarda o idioma escolhido em localStorage por padrão. Aqui o
	// localStorage não é usado para nada: cookie faz o mesmo trabalho e mantém
	// um só lugar de armazenamento no navegador.
	detection: {
		order: ["cookie", "navigator", "htmlTag"],
		caches: ["cookie"],
		lookupCookie: "i18nextLng"
	},
});

export { i18n };
